import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-reversal-pop-up',
  templateUrl: './investment-reversal-pop-up.component.html',
  styleUrls: ['./investment-reversal-pop-up.component.css']
})
export class InvestmentReversalPopUpComponent { }
